import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const relicDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 91: 白磁ティーポット
  91: (ctx, cx, cy, mode) => {
    const drawPot = () => {
      ctx.beginPath(); ctx.ellipse(cx, cy + 20, 95, 75, 0, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.moveTo(cx - 80, cy + 10); ctx.quadraticCurveTo(cx - 150, cy - 40, cx - 130, cy - 60); ctx.lineTo(cx - 70, cy - 10); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 90, cy + 20, 45, 0, Math.PI * 2); ctx.fill();
      drawPot(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx, cy - 60, 45, 18, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy - 80, 12, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.moveTo(cx - 80, cy + 10); ctx.quadraticCurveTo(cx - 150, cy - 40, cx - 130, cy - 60); ctx.lineTo(cx - 70, cy - 10); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 90, cy + 20, 45, 0, Math.PI * 2); ctx.stroke();
        drawPot(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy - 60, 45, 18, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 80, 12, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 20, 190, 150, PALETTE.white, 'ceramic');
      drawPot(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 20, 190, 60, PALETTE.deepBlue, 'ceramic');
      ctx.beginPath(); ctx.ellipse(cx, cy + 20, 95, 30, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 60, 90, 36, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.ellipse(cx, cy - 60, 45, 18, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy - 80, 12, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy, 30, 25, 0.7);
    }
  },

  // STAGE 92: 帝国皇帝の黄金クラウン
  92: (ctx, cx, cy, mode) => {
    const drawCrown = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 120, cy + 80);
      ctx.lineTo(cx - 120, cy - 50);
      ctx.lineTo(cx - 60, cy);
      ctx.lineTo(cx, cy - 90);
      ctx.lineTo(cx + 60, cy);
      ctx.lineTo(cx + 120, cy - 50);
      ctx.lineTo(cx + 120, cy + 80);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCrown(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy + 10, 80, Math.PI, 0); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCrown(); ctx.stroke();
        ctx.strokeRect(cx - 120, cy + 40, 240, 40);
        ctx.beginPath(); ctx.arc(cx - 60, cy + 60, 12, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy + 60, 14, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 60, cy + 60, 12, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 10, 160, 80, PALETTE.crimson, 'cloth');
      ctx.beginPath(); ctx.arc(cx, cy + 10, 80, Math.PI, 0); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 240, 170, PALETTE.gold, 'metallic');
      drawCrown(); ctx.fill();
      ctx.fillStyle = PALETTE.deepBlue;
      ctx.beginPath(); ctx.arc(cx - 60, cy + 60, 12, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 60, cy + 60, 12, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.ruby;
      ctx.beginPath(); ctx.arc(cx, cy + 60, 14, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx, cy - 70, 20, 20, 0.75);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 100, cy - 35, 15, 15, 0.7);
    }
  },

  // STAGE 93: 大航海時代の財宝箱
  93: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy - 20, 120, Math.PI, 0); ctx.fill();
      ctx.fillRect(cx - 120, cy - 20, 240, 150);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx, cy - 20, 120, Math.PI, 0); ctx.stroke();
        ctx.strokeRect(cx - 120, cy - 20, 240, 150);
        ctx.strokeRect(cx - 80, cy - 130, 25, 260);
        ctx.strokeRect(cx + 55, cy - 130, 25, 260);
        ctx.strokeRect(cx - 25, cy - 35, 50, 45);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 240, 270, PALETTE.darkWood, 'wood');
      ctx.beginPath(); ctx.arc(cx, cy - 20, 120, Math.PI, 0); ctx.fill();
      ctx.fillRect(cx - 120, cy - 20, 240, 150);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 80, cy, 25, 260, PALETTE.charcoal, 'metallic');
      ctx.fillRect(cx - 80, cy - 130, 25, 260);
      ctx.fillRect(cx + 55, cy - 130, 25, 260);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 12, 50, 45, PALETTE.gold, 'metallic');
      ctx.fillRect(cx - 25, cy - 35, 50, 45);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 45, cy - 70, 45, 20, 0.45);
    }
  },

  // STAGE 94: クリスタルドラゴン
  94: (ctx, cx, cy, mode) => {
    const drawDragonHead = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 140, cy + 20);
      ctx.lineTo(cx - 40, cy - 70);
      ctx.lineTo(cx + 70, cy - 130);
      ctx.lineTo(cx + 60, cy - 40);
      ctx.lineTo(cx + 120, cy + 20);
      ctx.lineTo(cx - 20, cy + 90);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawDragonHead(); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx - 80, cy + 70, 30, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawDragonHead(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 80, cy + 70, 30, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      const grad = ctx.createLinearGradient(cx - 140, cy - 130, cx + 120, cy + 90);
      grad.addColorStop(0, PALETTE.cyan);
      grad.addColorStop(0.65, PALETTE.purple);
      grad.addColorStop(1, PALETTE.gold);
      ctx.fillStyle = grad; drawDragonHead(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 80, cy + 70, 60, 60, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx - 80, cy + 70, 30, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 50, 35, 35, 0.7);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 88, cy + 62, 12, 12, 0.8);
    }
  },

  // STAGE 95: 伝説の聖剣エクスカリバー
  95: (ctx, cx, cy, mode) => {
    const drawSword = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy - 220);
      ctx.lineTo(cx + 30, cy - 170);
      ctx.lineTo(cx + 25, cy + 60);
      ctx.lineTo(cx - 25, cy + 60);
      ctx.lineTo(cx - 30, cy - 170);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawSword(); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.roundRect(cx - 95, cy + 60, 190, 24, 8); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.fillRect(cx - 12, cy + 84, 24, 70);
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx, cy + 170, 18, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawSword(); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx, cy - 220); ctx.lineTo(cx, cy + 60); ctx.stroke();
        ctx.beginPath(); ctx.roundRect(cx - 95, cy + 60, 190, 24, 8); ctx.stroke();
        ctx.strokeRect(cx - 12, cy + 84, 24, 70);
        ctx.beginPath(); ctx.arc(cx, cy + 170, 18, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 80, 60, 280, PALETTE.silver, 'metallic');
      drawSword(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 72, 190, 24, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.roundRect(cx - 95, cy + 60, 190, 24, 8); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, cy + 170, 18, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.fillRect(cx - 4, cy - 160, 8, 200);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 8, cy - 120, 12, 70, 0.7);
    }
  },

  // STAGE 96: 不死鳥フェニックスの盾
  96: (ctx, cx, cy, mode) => {
    const drawShield = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 110, cy - 140);
      ctx.lineTo(cx + 110, cy - 140);
      ctx.lineTo(cx + 110, cy);
      ctx.bezierCurveTo(cx + 110, cy + 100, cx, cy + 170, cx, cy + 190);
      ctx.bezierCurveTo(cx, cy + 170, cx - 110, cy + 100, cx - 110, cy);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawShield(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawShield(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 20, 45, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 20, 220, 330, PALETTE.crimson, 'lacquer');
      drawShield(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 180, 160, PALETTE.gold, 'metallic');
      ctx.beginPath();
      ctx.moveTo(cx, cy - 80);
      ctx.bezierCurveTo(cx + 80, cy - 120, cx + 90, cy, cx, cy + 80);
      ctx.bezierCurveTo(cx - 90, cy, cx - 80, cy - 120, cx, cy - 80);
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = PALETTE.orange;
      ctx.beginPath(); ctx.arc(cx, cy - 20, 25, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 70, 45, 30, 0.6);
    }
  },

  // STAGE 97: 千夜一夜の魔法ランプ
  97: (ctx, cx, cy, mode) => {
    const drawLampBody = () => {
      ctx.beginPath(); ctx.ellipse(cx - 20, cy + 30, 90, 50, 0, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath();
      ctx.moveTo(cx - 70, cy + 20); ctx.quadraticCurveTo(cx - 160, cy - 20, cx - 140, cy - 80); ctx.lineTo(cx - 50, cy + 5); ctx.closePath(); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 80, cy + 10, 40, 0, Math.PI * 2); ctx.fill();
      drawLampBody(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx - 20, cy + 80, 55, 18, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx - 20, cy - 20, 35, 15, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath();
        ctx.moveTo(cx - 70, cy + 20); ctx.quadraticCurveTo(cx - 160, cy - 20, cx - 140, cy - 80); ctx.lineTo(cx - 50, cy + 5); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 80, cy + 10, 40, 0, Math.PI * 2); ctx.stroke();
        drawLampBody(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx - 20, cy + 80, 55, 18, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx - 20, cy - 20, 35, 15, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx - 20, cy + 30, 180, 100, PALETTE.gold, 'metallic');
      drawLampBody(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx - 20, cy + 80, 55, 18, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx - 20, cy - 20, 35, 15, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx - 140, cy - 100, 24, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.purple;
      ctx.beginPath(); ctx.arc(cx - 120, cy - 140, 35, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 45, cy + 15, 35, 18, 0.7);
    }
  },

  // STAGE 98: 天文オルゴール
  98: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.roundRect(cx - 100, cy + 20, 200, 130, 16); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy + 20, 95, Math.PI, 0); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.roundRect(cx - 100, cy + 20, 200, 130, 16); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy + 20, 95, Math.PI, 0); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 20, 40, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 85, 200, 130, PALETTE.darkWood, 'wood');
      ctx.beginPath(); ctx.roundRect(cx - 100, cy + 20, 200, 130, 16); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 20, 190, 95, PALETTE.navy, 'glass');
      ctx.beginPath(); ctx.arc(cx, cy + 20, 95, Math.PI, 0); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 20, 80, 80, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy - 20, 40, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 45, 45, 25, 0.65);
    }
  },

  // STAGE 99: 大航海者の天球儀
  99: (ctx, cx, cy, mode) => {
    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.arc(cx, cy - 20, 115, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx, cy - 20, 95, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx, cy - 20, 60, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.fillRect(cx - 10, cy + 95, 20, 65);
      ctx.beginPath(); ctx.ellipse(cx, cy + 160, 75, 22, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        ctx.beginPath(); ctx.arc(cx, cy - 20, 115, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 20, 95, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 20, 60, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 10, cy + 95, 20, 65);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 20, 230, 230, PALETTE.brass, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy - 20, 115, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.navy;
      ctx.beginPath(); ctx.arc(cx, cy - 20, 60, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.beginPath(); ctx.ellipse(cx, cy - 20, 60, 20, 0.4, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 20, cy - 35, 20, 20, 0.65);
    }
  },

  // STAGE 100: 塗聖の極印・最終秘宝
  100: (ctx, cx, cy, mode) => {
    const drawSealOctagon = (r: number) => {
      ctx.beginPath();
      for (let i = 0; i < 8; i++) {
        const a = (i * Math.PI) / 4 + Math.PI / 8;
        const px = cx + Math.cos(a) * r;
        const py = cy + Math.sin(a) * r;
        if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
      }
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawSealOctagon(130); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; drawSealOctagon(95); ctx.fill();
      ctx.fillStyle = '#FAF8F5'; ctx.beginPath(); ctx.arc(cx, cy, 50, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawSealOctagon(130); ctx.stroke();
        drawSealOctagon(95); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 50, 0, Math.PI * 2); ctx.stroke();
      }, 4.0);
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 260, 260, PALETTE.gold, 'metallic');
      drawSealOctagon(130); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 190, 190, PALETTE.crimson, 'lacquer');
      drawSealOctagon(95); ctx.fill();
      ctx.fillStyle = PALETTE.cyan;
      ctx.beginPath(); ctx.arc(cx, cy, 50, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.gold;
      ctx.fillRect(cx - 25, cy - 15, 50, 30);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy - 40, 45, 45, 0.75);
    }
  }
};
